import { Button, withStyles } from '@material-ui/core';
export const FeedbackButtonStyled = withStyles({
    root: {
        padding: 0,
    },
    label: {
        fontSize: '14px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
    },
})(Button);
